import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { addToCart } from '../../redux/actions/cartActions';

const ImageSection = ({product}) => {
  const dispatch=useDispatch();
  const navigate=useNavigate();
  const {id}=product;
 
  const [quantity,setQuantity]=useState(1);

  const addItemToCart=()=>{
    console.log('id');
    console.log(id);
    dispatch(addToCart(id,quantity));
    navigate('/cart');
  }
  return (
    <>
      <div className=''>
            <img src={product.detailUrl} alt="" className='w-[300px'/>
            <div className='flex space-x-[20px] justify-center my-[30px]'>
                <button className='bg-pink-700 text-white px-[12px] py-[8px] rounded-xl drop-shadow-xl' onClick={addItemToCart}>Add to cart</button>
                <button className='bg-green-500 text-white px-[12px] py-[8px] rounded-xl drop-shadow-xl'>Buy Now</button>
            </div>
      </div>
    </>
  )
}

export default ImageSection
